/**
 * External Dependencies
 */

import {tns} from 'tiny-slider/src/tiny-slider.js';

var elements = {};

document.addEventListener('DOMContentLoaded', () => {
    elements.body = document.body;
    elements.toggler = document.getElementById('toggler');

    elements.toggler.addEventListener('click', toggleMobileMenu);
    addReturnLink();
    toggleParentMenuItems();
    initSlider();
});

function toggleMobileMenu()
{
    let menu = document.getElementById('navigation');
    menu.classList.toggle('mainNavigation--active');
    elements.toggler.classList.toggle('menuToggler--close');
    elements.body.classList.toggle('mainNavigation--isOpen');
}

function addReturnLink()
{
    let closestSubMenus = document.querySelectorAll('.mainNavigation__list > li.menu-item-has-children > ul.sub-menu');

    // create return link
    const returnToParentItem = document.createElement('li');
    returnToParentItem.classList.add('returnLink');
    const returnToParentLink = document.createElement('a');
    returnToParentLink.appendChild(document.createTextNode('Terug naar overzicht'));
    returnToParentItem.appendChild(returnToParentLink);

    for (let i = 0; i < closestSubMenus.length; i++) {
        let subMenu = closestSubMenus[i];
        let subMenuFirstItem = subMenu.querySelector('li');
        let returnToParentElem = returnToParentItem.cloneNode(true);
        subMenu.insertBefore(returnToParentElem, subMenuFirstItem);
        returnToParentElem.addEventListener('keyup', function (event) {
            if (event.key === 'Escape') {
                // TODO: close parent menu without depending on event.target
            }
        });
        returnToParentElem.addEventListener('click', function (event) {
            event.target.closest('.menu-item-has-children').classList.remove('open');
        });
    }
}

function toggleParentMenuItems()
{
    let parentMenuItems = document.querySelectorAll('.mainNavigation__list > li.menu-item-has-children > a');
    
    for (let i = 0; i < parentMenuItems.length; i++) {
        parentMenuItems[i].addEventListener('click', function (event) {
            event.preventDefault();
            event.target.parentElement.classList.toggle('open');
        });
    }
}

function initSlider()
{
    const sliderWrappers = document.body.querySelectorAll('.sponsorSlider__wrapper');
    if (sliderWrappers.length === 0) {
        return;
    }
    sliderWrappers.forEach((sliderNode) => {
        tns({
            container: sliderNode,
            items: 1,
            nav: false,
            gutter: 20,
            edgePadding: 50,
            fixedWidth: 150,
            controlsContainer: '.sponsorSlider__controls',
            mouseDrag: true,
            autoplay: true,
            loop: true,
            autoplayTimeout: 0,
            autoplayHoverPause: true,
            preventActionWhenRunning:true,
            speed: 3000,
            autoplayButtonOutput: false,
            responsive: {
                500: {
                    items: 2,
                },
                700: {
                    items: 3,
                },
                900: {
                    items: 4,
                    edgePadding: 0,
                    mouseDrag: false,
                },
            },
        });
    });
}
